export interface ManagementServicesState {
  managementServices: any[];
  managementServicesItem?: ManagementServicesItem;
}

export interface ManagementServicesFilter {
  partner?: string;
  service_provider_id?: string;
  mn_service_name?: string;
  status?: string;
  query?: string;
}

export interface ManagementServicesItem {
  id?: number;
  service_provider_id: string;
  service_provider_name: string;
  mn_service_name: string;
  status: number;
  description?: string;
  partner_ids: (number | undefined)[];
  partners: ManagementServicesPartnerItem[];
}

export class ManagementServicesItemImpl implements ManagementServicesItem {
  service_provider_id: string;
  service_provider_name: string;
  mn_service_name: string;
  status: number;
  partner_ids: number[];
  partners: ManagementServicesPartnerItem[];
  constructor() {
    this.service_provider_id = "";
    this.service_provider_name = "";
    this.mn_service_name = "";
    this.status = 0;
    this.partner_ids = [];
    this.partners = [];
  }
}

export interface ManagementServicesPartnerItem {
  id?: number;
  partner_name: string;
  allowed: boolean;
}
